import api from 'api'
import { PbxSmsCampaignDetails } from 'types/PbxSmsCampaignDetails'
import { fetchWithToken } from 'utils'

const fetchPbxSmsCampaignDetails = async (selectedPbxId: string): Promise<PbxSmsCampaignDetails> => {
  const route = `accounts/${selectedPbxId}/pbx-campaign-details`

  return fetchWithToken({
    method: 'GET',
    resource: api.numbers,
    path: route,
    useV5: false,
    useVersion: 'v3',
  })
    .then((response: Response) => response.json())
    .catch((err: Error) => {
      // Something wrong happened during the fetch
      console.error(err.toString())
    })
}

export default fetchPbxSmsCampaignDetails
